import { checkIsDateRangeEqual } from "@repo/app-types/entities/dateRange";
import isEqual from "lodash-es/isEqual.js";
import type { FilterKey, FilterValues } from "./filterState.js";

type FilterEqualityComparatorMapping = {
  [F in FilterKey]: FilterEqualityComparator<F>;
};

type FilterEqualityComparator<F extends FilterKey> = (
  a: FilterValues[F],
  b: FilterValues[F],
) => boolean;

const filterEqualityComparators: FilterEqualityComparatorMapping = {
  teammateGroupIds: (a, b) =>
    Array.isArray(a) && Array.isArray(b)
      ? isEqual(new Set(a), new Set(b))
      : a === b,
  byGroupTeammateGroupIds: (a, b) =>
    Array.isArray(a) && Array.isArray(b)
      ? isEqual(new Set(a), new Set(b))
      : a === b,
  dateBasis: (a, b) => a === b,
  dateRange: checkIsDateRangeEqual,
  playbookConditions: isEqual,
  customFields: isEqual,
  outcome: isEqual,
  signalId: (a, b) => a === b,
  signalMetadataFields: isEqual,
  totalRecordingDuration: isEqual,
  coachingGoal: isEqual,
};

export function checkIsFilterEqual<F extends FilterKey>(
  filterKey: F,
  a: FilterValues[F],
  b: FilterValues[F],
): boolean {
  return filterEqualityComparators[filterKey](a, b);
}
